export type ApplyOptimisticUpdate = (
  syncId: string,
  targetItems: Array<{ item_id: number; board_id: number }>,
  // Threaded straight from columnValuesResync.value (SyncLatestModal's
  // resyncPayload.latestUpdate.value) with no transformation, so it carries the same shape.
  newValue: string | Array<{ id: number | string; label: string }> | null,
  newText: string,
  columnType: string,
  columnTitle: string,
  columnHasDiscrepancy: boolean,
) => void;

export interface SharedColumnsProps {
  syncId: string;
  dbItems: any[];
  discrepancyItems: any[];
  sharedColumns: any[];
  totalDiscrepancies: number;
  filter: string;
  applyOptimisticUpdate: ApplyOptimisticUpdate;
  /**
   * Fired after a resync POST succeeds. applyOptimisticUpdate patches the PARENT's
   * discrepancies array, which drives the row's badge and state pill — but the values the grid
   * renders come from whoever owns `discrepancyItems`, and for a cache-seeded row that is
   * ExpandedRow's own fetch state. Nothing the patch touches can reach it, so the owner of
   * those values has to be told to reconcile them.
   */
  onResynced?: () => void;
  /** Values are still being fetched — the grid renders its own skeleton rows. */
  isLoading?: boolean;
}

export interface ResyncPayloadInterface {
  latestUpdate: columnValuesResync;
  targetItems: columnValuesResync[];
}

export type columnValuesResync = {
  item_id: number;
  board_id: number;
  last_updated?: number;
  formattedDate?: string;
  column_type: string;
  column_title: string;
  // null when the column does not exist on that board.
  column_id: string | null;
  // A raw column value for most types; a dropdown's `values` array (its resync
  // payload shape) when column_type is "dropdown".
  value: string | Array<{ id: number | string; label: string }> | null;
  text: string;
  exists: boolean;
  /**
   * The ITEM's `updated_at` (ISO), carried only for `column_type === "name"`. A name has no
   * column activity log to rank by, so "latest wins" for a rename ranks on this instead —
   * the same rule the subitem engine applies with the subitem's updated_at.
   */
  updated_at?: string | null;
};

/** The synthetic shared column utils-ms emits when the mirrors' names disagree. */
export const NAME_COLUMN_TYPE = "name";

export type ColumnType = {
  id: string;
  title: string;
  type: string;
};
